import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXMortgageQuote implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxMortgageQuoteContainer";
    }
    render(){
        // console.log("inquiry");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxMortgageQuoteContainer", "firstName", "local_lead_first_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxMortgageQuoteContainer", "lastName", "local_lead_last_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxMortgageQuoteContainer", "phone", "local_lead_phone");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxMortgageQuoteContainer", "email", "local_lead_email");
    }
}